import React from 'react';
import DefaultLanguage from './parts/DefaultLanguage';
import DefaultTheme from './parts/DefaultTheme';
import DefaultTimeZone from './parts/DefaultTimeZone/DefaultTimeZone';
import DefaultFontSize from './parts/DefaultFontSize';

const UserSettingsDetails = () => (
  <>
    <DefaultLanguage />
    <DefaultTheme />
    <DefaultFontSize />
    <DefaultTimeZone />
  </>
);

export default UserSettingsDetails;
